import Product from '@/finsight/domain/Product';
import Region from '@/finsight/domain/Region';
import { setPageNotFound } from '@/finsight/application/actions/redirect/actions';
import { isValidSectorIndustry } from '@/finsight/application/actions/profile/helpers/isValidSectorIndustry';
import { collectBaseFiltersData } from './collectBaseFiltersData';
import { getFiltersByPairs } from '@/finsight/application/actions/profile/helpers/getFiltersByPairs';
import { IBaseProfileFiltersConfig } from './types';

interface IBaseFilters {
  getChartBy: string,
  getDealsBy: string,
  getTopCompaniesBy: string,
  isConsumerOverview: boolean,
  isOverview: boolean,
  productIds: string[],
  regionIds: string[],
  industry: Record<string, any> | null,
  sector: Record<string, any> | null,
  sectorBlock: boolean,
  skipNextUpdate: IBaseProfileFiltersConfig['skipNextUpdate'],
}

export const getBaseProfileFilters = ({ ...config }: IBaseProfileFiltersConfig): IBaseFilters => {
  const { dispatch, profileType, headerData } = config;

  const {
    validProducts,
    validRegions,
    industry,
    sector,
    isConsumerOverview,
    skipNextUpdate,
  } = collectBaseFiltersData({ ...config });

  let filters = {
    productIds: Product.getIDsByAbbreviations(headerData.products, validProducts),
    regionIds: Region.getIDsByAbbreviations(headerData.regions, validRegions),
    sector: null,
    industry: null,
    isOverview: (!industry && !sector),
    isConsumerOverview,
    skipNextUpdate,
  };

  if (sector) {
    if (!isValidSectorIndustry(headerData.sectorsList, sector)) {
      dispatch(setPageNotFound(true));
      return null;
    }

    filters = {
      ...filters,
      sector: headerData.sectorsList[sector],
    };
  }

  if (industry) {
    if (!isValidSectorIndustry(headerData.industriesList, industry)) {
      dispatch(setPageNotFound(true));
      return null;
    }

    filters = {
      ...filters,
      industry: headerData.industriesList[industry],
    };
  }

  const profileFilters = getFiltersByPairs({
    mapping: headerData.mapping,
    profileType,
    selectedProducts: filters.productIds,
    selectedRegions: filters.regionIds,
  });

  return {
    ...filters,
    ...profileFilters,
  };
};
